import type { FC } from 'react'
import { HStack, Skeleton, Stack, VStack, WrapItem } from '@chakra-ui/react'

const Row: FC = () => (
  <HStack w="full">
    <Skeleton flex={1} h="14px" />
    <Skeleton flex={1} h="14px" />
  </HStack>
)

const CustomerOrderItemSkeleton: FC = () => {
  return (
    <Stack
      borderColor="text.mild"
      borderRadius="md"
      borderWidth="1px"
      flexDirection={{ base: 'column', md: 'row' }}
      p={2}
      w="full"
    >
      <WrapItem flex={1}>
        <VStack w="full">
          <Row />
          <Row />
          <Row />
        </VStack>
      </WrapItem>
      <WrapItem flex={1}>
        <VStack w="full">
          <Row />
          <Row />
          <Row />
        </VStack>
      </WrapItem>
    </Stack>
  )
}

export default CustomerOrderItemSkeleton
